import { Grey } from '@/styles/Colors';
import { FontSize, FontWeight } from '@/styles/Typography';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

interface StyledInputLabelProps {
  isSimple?: boolean;
}

const StyledInputLabel = styled.label(
  ({ isSimple }: StyledInputLabelProps) => css`
    display: inline-flex;
    align-items: center;
    background-color: ${Grey[500]};
    border: 1px solid ${Grey[500]};
    border-radius: 0.25rem;
    font-size: ${FontSize['Lg']};
    line-height: 150%;
    padding: ${isSimple ? '0.25rem 0.5rem' : '0.25rem'};
    cursor: pointer;
    color: ${Grey[50]};
    gap: 0.5rem;
    font-weight: ${FontWeight['SemiBold']};
    ~ input {
      /* Visually hidden, NOT hidden from the keyboard (ISSUE-065).
         'visibility: hidden' removed the file input from the focus order and
         the accessibility tree, and the label carries no tabindex, so there
         was no keyboard path to it at all (SC 2.1.1, Level A). */
      position: absolute;
      width: 1px;
      height: 1px;
      margin: -1px;
      padding: 0;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      white-space: nowrap;
      border: 0;
    }
  `
);
export { StyledInputLabel };
